<div>
  <span>
    <fa-icon icon="arrow-up"></fa-icon>
    {{title}}
    <fa-icon icon="arrow-up"></fa-icon>
  </span>
</div>
